import nycParking from '../../../images/nycParking.jpg';
import lockbox1 from '../../../images/lockbox1.jpg';

import OpenBox from './OpenBox';
import BeforeDrivingList from './StartYourBooking/BeforeDrivingList';
import UberDriver from './UberDriver';
import DriverAccident from './AccidentsAndInsurance/DriverAccident';
import FlatTire from './DrivesharingPolicies/FlatTire';
import CarNotInSpot from './DrivesharingPolicies/CarNotInSpot';
import VehicleInUse from './VehicleInUse';
import AccessByCarNYC from './AccessByCarNYC';
import FindLockCode from './FindLockCode';
import IssueWhatToDo from './IssueWhatToDo';
import CancelBooking from './MakingABooking/CancelBooking';
import DrivingPLUS from './DrivingPLUS';
import AccessByWalkNYC from './AccessByWalkNYC';
import KeyCardNYC from './KeyCardNYC';
import VehicleLate from './VehicleLate';
import RightPlateVia from './RightPlateVia';
import SkyportManhattan from './SkyportManhattan';

import React from 'react';
import GasPolicy from './DrivesharingPolicies/GasPolicy';

const OpenBoxFunc = () => <OpenBox city="new_york" />;
const BeforeDrivingListFunc = () => <BeforeDrivingList city="new_york" />;
const DriverAccidentFunc = () => <DriverAccident city="new_york" />;
const FlatTireFunc = () => <FlatTire />;
const NotFullFunc = () => <GasPolicy city="new_york" />;
const CarNotInSpotFunc = () => <CarNotInSpot />;
const VehicleInUseFunc = () => <VehicleInUse city="new_york" />;
const FindLockCodeFunc = () => <FindLockCode />;
const IssueWhatToDoFunc = () => <IssueWhatToDo />;
const CancelBookingFunc = () => <CancelBooking />;
const VehicleLateFunc = () => <VehicleLate />;
const RightPlateViaFunc = () => <RightPlateVia />;
const SkyportManhattanFunc = () => <SkyportManhattan />;

export const driverFaqDataNYC = [
  {
    heading: 'Important',
    content: [
      {
        title: 'Fuel Policy',
        info: [{ component: NotFullFunc }]
      },
      {
        title: 'Late Driver Policy',
        info: [{ component: CarNotInSpotFunc }]
      },
      {
        title:
          'I tried to go online with the vehicle in Via Driver App and it says “Shift Error”, what do I do?',
        info: [{ component: VehicleInUseFunc }]
      },
      {
        title: 'Can I return the car later than my booking end time?',
        info: [{ component: VehicleLateFunc }]
      }
    ]
  },
  {
    heading: 'Parking hubs',
    content: [
      {
        title: 'Skyport - Manhattan',
        info: [{ component: SkyportManhattanFunc }]
      }
    ]
  },
  {
    heading: 'About Via',
    content: [
      {
        title: 'What is Via?',
        info: [
          {
            text:
              'Via is the fastest growing rideshare company in NYC. It operates across the globe and has been picked by the world’s biggest cities and transit authorities to launch their technology as a solution to public transit.'
          },
          {
            text:
              'It provides shared rides with technology that allows for more efficient and greener ways to move around.'
          }
        ]
      },
      {
        title: 'How does Via work?',
        info: [
          {
            text:
              'Via matches multiple riders going in the same direction with vehicles following optimized roads, maximizing efficiency and minimizing detours. Because rides are shared, drivers pickup many riders throughout the day and maximize their earnings.'
          }
        ]
      },
      {
        title: 'How do I earn with Via?',
        info: [
          {
            text:
              'With Via, you have multiple earning options, hourly or by the ride. Via provides stability and flexibility on your earnings and has a low service fee of 10%.'
          }
        ]
      },
      {
        title: 'What are the benefits of driving a Metris with Via?',
        info: [
          {
            text:
              'The Mercedes-Benz Metris is Via’s preferred vehicle. Metris drivers earn the highest rates on the Via platform and enjoy exclusive perks, like a support line just for Metris Driver Partners.'
          }
        ]
      },
      {
        title: 'Where does Via operate in NYC?',
        info: [
          {
            text: 'Via operates in all 5 boroughs of New York City.'
          }
        ]
      }
    ]
  },

  {
    heading: 'Getting started',
    content: [
      {
        title: 'Where do I find the lock code?',
        info: [{ component: FindLockCodeFunc }]
      },
      {
        title: 'Where do I find the car key?',
        info: [
          {
            text:
              'There is a lock box secured to the wall under the Autzu reserved parking sign of the parking spot. You will find the specific parking spot number and lock box code for the vehicle assigned to you in a text message you will receive from us 10 minutes before your booking begins.'
          },
          {
            image: {
              src: lockbox1,
              alt: 'LockBox'
            }
          }
        ]
      },
      {
        title: 'How do I open and close the lock box?',
        info: [{ component: OpenBoxFunc }]
      },
      {
        title: 'What should I do before driving?',
        info: [{ component: BeforeDrivingListFunc }]
      },
      {
        title: 'Use the right plate in Via',
        info: [{ component: RightPlateViaFunc }]
        // info: [{ component: BeforeDrivingListFunc }],
      },
      {
        title: 'I found an issue with the vehicle, what should I do?',
        info: [{ component: IssueWhatToDoFunc }]
      },
      {
        title: 'How do I cancel a booking?',
        info: [{ component: CancelBookingFunc }]
      }
    ]
  },
  {
    heading: 'Emergency instructions',
    content: [
      {
        title: 'I was in an accident, what do I do?',
        info: [{ component: DriverAccidentFunc }]
      },
      {
        title: 'I have a flat tire, what do I do?',
        info: [{ component: FlatTireFunc }]
      },
      {
        title: 'I had a rude passenger, what should I do?',
        info: [
          {
            text:
              'Unfortunately, Autzu cannot assist with passenger-related issues, and it is up to your discretion on how to handle the situation.'
          },
          {
            text:
              'There are multiple support queries through the Via Driver app which can assist you. If you ever feel like you are in danger, please contact the authorities by calling 911.'
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/DriverFaqDataNYC.js